import { Flex as Flex$1, Stack as Stack$1 } from "../mantine-passthroughs/index.js";
import { Caption } from "../typography/Caption.js";
import { MinMaxLabels } from "./MinMaxLabels.js";
import { StartEndLabels } from "./StartEndLabels.js";
import { Progress } from "@mantine/core";
import { useMemo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/progress-bar/ProgressBar.tsx
const ProgressBar = ({ startLabel, endLabel, min, value, max, showComplete = false, helperText, maxFormatter, minFormatter, color: colorOverride, backgroundColor: backgroundColorOverride, showMinMaxLabels = true, "data-testid": testId }) => {
	const isComplete = value >= max;
	const currentPct = Math.round((value - min) / (max - min) * 100);
	const color = useMemo(() => {
		if (!showComplete) return "info";
		return isComplete ? "success" : "info";
	}, [isComplete, showComplete]);
	return /* @__PURE__ */ jsxs(Stack$1, {
		align: "stretch",
		gap: 2,
		style: { flexGrow: 1 },
		"data-testid": testId,
		children: [
			/* @__PURE__ */ jsx(StartEndLabels, {
				startLabel,
				endLabel
			}),
			showMinMaxLabels && /* @__PURE__ */ jsx(MinMaxLabels, {
				min,
				value,
				max,
				maxFormatter,
				minFormatter,
				showComplete
			}),
			/* @__PURE__ */ jsx(Progress, {
				color: colorOverride ?? color,
				radius: "xl",
				size: "sm",
				value: currentPct,
				style: { backgroundColor: backgroundColorOverride ? "var(backgroundColorOverride)" : "var(--mantine-color-info-0)" },
				__vars: { "--progress-size": "var(--progress-size-md)" }
			}),
			/* @__PURE__ */ jsx(Flex$1, {
				justify: "space-between",
				children: /* @__PURE__ */ jsx(Caption, { children: helperText })
			})
		]
	});
};

//#endregion
export { ProgressBar };